// extracted by mini-css-extract-plugin
export default {"container":"WelcomePackItemLabel_container--CYy","labelTitle":"WelcomePackItemLabel_labelTitle--QPm","imageContainer":"WelcomePackItemLabel_imageContainer--AmM"};